<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-form ref="searchEmp" :model="searchEmp" class="searchEmp">
				<el-row>
					<el-col :xs="24" :sm="13" :md="13" :lg="12">
						<el-form-item label-width="140px">
							<div slot="label">选择营业开始时间</div>
							<el-date-picker v-model="searchEmp.time" type="datetimerange" align="right" start-placeholder="开始日期"
								end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="12" style="float:right">
						<el-row style="text-align:end;width:100%">
							<el-button type="success" @click="add">新增</el-button>
							<el-button type="info" @click="clean_btn">重置</el-button>
							<el-button type="primary" @click="search_btn">查询</el-button>
						</el-row>
					</el-col>
				</el-row>
			</el-form>

			<Total :total="total"></Total>

			<!-- 表格 -->

			<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F1F2F7', color: '#606266' }"
				@cell-click="cellClick">
				<el-table-column prop="id" label="营业日志编号" min-width="120" align="center">
				</el-table-column>
				<!-- <el-table-column prop="csfzr" label="场所负责人" min-width="120" align="center">
				</el-table-column> -->
				<el-table-column prop="begintime" label="营业开始时间" min-width="160" align="center" :formatter="formatDate">
				</el-table-column>
				<el-table-column prop="endtime" label="营业结束时间" min-width="160" align="center" :formatter="formatDate">
				</el-table-column>
				<!-- <el-table-column prop="zafzr" label="治安负责人" min-width="100" align="center">
				</el-table-column> -->
				<el-table-column prop="ajfs" label="是否有治安/刑事/事故发生" min-width="220" align="center" show-overflow-tooltip
					:formatter="sfFliter">
				</el-table-column>
				<el-table-column prop="ischeck" label="是否有管理部门检查" min-width="170" align="center" :formatter="sfFliter">
				</el-table-column>
				<el-table-column prop="businessdesc" label="当日营业状况" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="createusername" label="创建人" align="center">
				</el-table-column>
				<el-table-column prop="createtime" label="创建时间" min-width="160" align="center" :formatter="formatDate">
				</el-table-column>
				<el-table-column label='操作' align='center' fixed="right">
					<template slot-scope='scope'>
						<el-button class='revise' size='mini' type='warning' plain @click.stop='revise(scope.row.id)'>修改</el-button>
					</template>
				</el-table-column>

			</el-table>

			<!-- 分页 -->

			<div class="page">
				<el-pagination v-if="tableData.length != 0" class="fy" style="" layout="prev, pager, next" :total="total"
					:page-size="pageData.page_size" :current-page="pageData.page_no" @current-change="current_change" background>
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
import Total from '@/components/total/index.vue'
import { getYylogList } from '@/api/day_work.js'
import { lists, filtersInfo } from '@/utils/dictionary.js'
import { formatDate } from '@/utils/index.js'
// filtersInfo
export default {
	name: "BusLogIndex",
	data() {
		return {
			breadcrumbList: [
				{ name: "营业日志", path: "bus_log" }
			],
			searchEmp: {},
			tableData: [],
			total: 0,
			pageData: {
				// count: null, //总数
				page_no: 1,  //现在
				page_size: 10, //每页条数
				// page:25 //总页数
			},
			sfList: [],
			loading: true
		}
	},
	created() {
		this.info()
	},
	methods: {

		async info() {
			const res = await getYylogList({ ...this.pageData, ...this.searchEmp })
			this.total = res.total_result
			this.pageData.page_no = res.page_no
			this.pageData.page_size = res.page_size
			this.tableData = res.items
			// 获取字典
			this.getZiDian()


		},
		add() {
			this.$router.push("/bus_log/add_bus_log");
		},
		revise(id) {
			this.$router.push({
				path: '/bus_log/add_bus_log',
				query: { id }
			})
		},
		clean_btn() { //重置
			this.searchEmp = {}
			this.info()
		},
		search_btn() { //查询
			// 当前页强制转为1
			this.pageData.page_no = 1
			const time = this.searchEmp.time
			this.searchEmp.start_time = time ? time[0] / 1000 : ''
			this.searchEmp.end_time = time ? time[1] / 1000 : ''
			this.info()
		},
		cellClick({ id }) { //点击单元格,跳转详情
			this.$router.push({
				path: '/bus_log/bus_log_details',
				query: { id }
			})
		},
		current_change(val) { //分页功能
			this.pageData.page_no = val
			this.info()
		},
		getZiDian() { //获取字典
			this.sfList = lists['SF']
		},
		formatDate(row, col, val) {
			if (!val && val != 0) return
			return formatDate(val)
		},
		sfFliter(row, col, val) {
			if (!val && val != 0) return
			return filtersInfo(this.sfList, val)
		},
	},
	beforeRouteLeave(to, from, next) {
		//离开页面如果去的详情  则缓存当前页面
		if (to.path === '/bus_log/bus_log_details') {
			this.$store.commit('setKeep', 'BusLogIndex')
			next()
		} else {
			this.$store.commit('setKeep', '')
			next()
		}
		next()
	},
	components: { Total }
}
</script>

<style lang="less" scoped>
.revise {
	border-radius: 16px;
}
</style>